import { createSlice } from '@reduxjs/toolkit';
import { RoleState } from '../types/role.types';

const initialState: RoleState = {
  assignedRolesData: [],
};

const roleSlice = createSlice({
  name: 'role',
  initialState: initialState,
  reducers: {
    updateAssignedRoles: (state: RoleState, action) => {
      state.assignedRolesData = action.payload;
    },
    getAssignedRolesAction: () => {
      return;
    },

    postRoleDataAction: () => {
      return;
    },
  },
});

export const {
  getAssignedRolesAction,
  updateAssignedRoles,
postRoleDataAction,
} = roleSlice.actions;
export default roleSlice.reducer;
